import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Tooltip from '@mui/material/Tooltip';
import { createSvgIcon } from '@mui/material/utils';
import Delete from '@mui/icons-material/Delete';
import { useTranslation } from 'next-i18next';

export interface ImageResizeMenuProps {
  onWrapLeft: () => void;
  onWrapRight: () => void;
  onAlignLeft: () => void;
  onAlignCenter: () => void;
  onAlignRight: () => void;
  onDelete: () => void;
}

export function ImageResizeMenu({
  onWrapLeft,
  onWrapRight,
  onAlignLeft,
  onAlignCenter,
  onAlignRight,
  onDelete,
}: ImageResizeMenuProps) {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      <ButtonGroup variant="contained">
        <Tooltip title={t('Wrap Left')}>
          <Button onClick={onWrapLeft}>
            <WrapLeft />
          </Button>
        </Tooltip>
        <Tooltip title={t('Wrap Right')}>
          <Button onClick={onWrapRight}>
            <WrapRight />
          </Button>
        </Tooltip>
        <Tooltip title={t('Align Left')}>
          <Button onClick={onAlignLeft}>
            <AlignLeft />
          </Button>
        </Tooltip>
        <Tooltip title={t('Align Center')}>
          <Button onClick={onAlignCenter}>
            <AlignCenter />
          </Button>
        </Tooltip>
        <Tooltip title={t('Align Right')}>
          <Button onClick={onAlignRight}>
            <AlignRight />
          </Button>
        </Tooltip>
        <Tooltip title={t('Delete')}>
          <Button onClick={onDelete}>
            <Delete />
          </Button>
        </Tooltip>
      </ButtonGroup>
    </Box>
  );
}

const WrapLeft = createSvgIcon(
  <path d="M2 2H22V3.53846H2V2ZM13.25 6.61538H22V8.15385H13.25V6.61538ZM13.25 11.2308H22V12.7692H13.25V11.2308ZM2 20.4615H22V22H2V20.4615ZM13.25 15.8462H22V17.3846H13.25V15.8462ZM2 8.15385H10.75V15.8462H2V8.15385Z" />,
  'WrapLeft',
);
const WrapRight = createSvgIcon(
  <path d="M2 2H22V3.53846H2V2ZM2 6.61538H10.75V8.15385H2V6.61538ZM2 11.2308H10.75V12.7692H2V11.2308ZM2 20.4615H22V22H2V20.4615ZM2 15.8462H10.75V17.3846H2V15.8462ZM13.25 8.15385H22V15.8462H13.25V8.15385Z" />,
  'WrapRight',
);
const AlignLeft = createSvgIcon(
  <path d="M2 2H22V3.53846H2V2ZM2 8.15385H12V15.8462H2V8.15385ZM2 20.4615H22V22H2V20.4615Z" />,
  'AlignLeft',
);
const AlignCenter = createSvgIcon(
  <path d="M2 2H22V3.53846H2V2ZM22 20.4615V22H2V20.4615H22ZM17 8.15385V15.8462H7V8.15385H17Z" />,
  'AlignCenter',
);
const AlignRight = createSvgIcon(
  <path d="M2 2H22V3.53846H2V2ZM12 8.15385H22V15.8462H12V8.15385ZM2 20.4615H22V22H2V20.4615Z" />,
  'AlignRight',
);

export default ImageResizeMenu;
